import { render, staticRenderFns } from "./Preventive.vue?vue&type=template&id=5a2e6ca2&scoped=true"
import script from "./Preventive.vue?vue&type=script&lang=js"
export * from "./Preventive.vue?vue&type=script&lang=js"
import style0 from "./Preventive.vue?vue&type=style&index=0&id=5a2e6ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2e6ca2",
  null
  
)

export default component.exports